import {
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  CreateHostLevel,
  CreateSenderLevel,
  uploadFile,
} from "../../DAL/create";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { enqueueSnackbar } from "notistack";
export const AddHostLevel = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    level: "",
    diamonds: "",
    image: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [type, setType] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value < 0 ? 0 : e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };
  const handleImageUpload = async (e) => {
    const value = e.target.files[0];
    setPreviewImage(URL.createObjectURL(value));
    setInputs((prev) => ({ ...prev, image: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputs?.level == "") {
      setType(true);
      return;
    }
    if (inputs?.diamonds == "") {
      setType(true);
      return;
    }
    if (!inputs?.image) {
      setType(true);
      return;
    }
    const formData = new FormData();
    formData.append("level", inputs?.level);
    formData.append("rcoin", inputs?.diamonds);
    formData.append("file", inputs?.image);
    const resp = await CreateHostLevel(formData);
    if (resp.data?.statusCode == 201) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      navigate("/hosts-list");
    } else {
      enqueueSnackbar(resp?.message, { variant: "error" });
    }
  };

  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };
  return (
    <>
      <div className="mainDiv">
        <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/hosts-list")}
          />
          <Typography variant="h6">Add Host Level</Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "6px" }}>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter Level *"
              type="number"
              value={inputs?.level}
              name="level"
              onChange={handleChange}
              sx={inputStyles}
              InputLabelProps={{ sx: labelStyles }}
            />
            <FormHelperText sx={{ color: "red" }}>
              {type == true && inputs?.level == "" && "Level is Required"}
            </FormHelperText>
          </Grid>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter Rcoins *"
              type="number"
              value={inputs?.diamonds}
              name="diamonds"
              onChange={handleChange}
              sx={inputStyles}
              InputLabelProps={{ sx: labelStyles }}
            />
            <FormHelperText sx={{ color: "red" }}>
              {type == true && inputs?.diamonds == "" && "Rcoins Field is Required"}
            </FormHelperText>
          </Grid>
          <Grid item lg={12}>
            <Grid container spacing={2}>
              <Grid item lg={4}>
                <Typography>Upload Image *</Typography>
                <FormHelperText>Image Size(200X100)</FormHelperText>
              </Grid>
              <Grid item lg={2} sx={{ textAlign: "center" }}>
                {previewImage && (
                  <img
                    src={previewImage}
                    alt=""
                    style={{ width: "80%", height: "70px" }}
                  />
                )}
                <FormHelperText sx={{ color: "red" }}>
                  {type == true && inputs?.image == "" && "Image is Required"}
                </FormHelperText>
              </Grid>
              <Grid item lg={6} sx={{ textAlign: "end" }}>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="upload-button"
                  type="file"
                  name="image"
                  onChange={handleImageUpload}
                />
                <label htmlFor="upload-button">
                  <Button
                    variant="contained"
                    component="span"
                    className="gradientButton"
                  >
                    Upload
                  </Button>
                </label>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} sx={{ textAlign: "end" }}>
            <Button
              variant="contained"
              className="gradientButton"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
